import { render, staticRenderFns } from "./MetricTotal.vue?vue&type=template&id=9c83e1ac&"
import script from "./MetricTotal.vue?vue&type=script&lang=js&"
export * from "./MetricTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports